var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "filter-or-criteria",
      class: { "filter-inputs-lg": _vm.isFullWidth }
    },
    [
      _c(
        "div",
        { staticClass: "p-r-20 slide-down" },
        [
          _vm.orIndex > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "m-t-10 m-b-15 text-center filter-or-criteria__or-text"
                },
                [
                  _c("strong", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "ROUTER_FILTER_OR",
                        expression: "'ROUTER_FILTER_OR'"
                      }
                    ],
                    staticClass: "m-l-15"
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isReadOnly && _vm.isEditView
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "filter-inputs",
                    class: { "filter-item-geo": _vm.isGeoTag }
                  },
                  [
                    !_vm.isFullWidth || _vm.isMobileView
                      ? _c("SearchableDropdown", {
                          attrs: {
                            config: _vm.tagsOptions,
                            placeholder: _vm.$t("ROUTER_TAG_SELECT_PH"),
                            rules: "required",
                            required: ""
                          },
                          model: {
                            value: _vm.criteriaTag,
                            callback: function($$v) {
                              _vm.criteriaTag = $$v
                            },
                            expression: "criteriaTag"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ValidationProvider",
                      { attrs: { rules: "required", slim: "" } },
                      [
                        _vm.isFullWidth && !_vm.isMobileView
                          ? _c("TagSelector", {
                              staticClass: "filter-tag-id",
                              attrs: {
                                tags: _vm.availableTags,
                                "form-name": _vm.formNameForUserSettings
                              },
                              on: { change: _vm.onTagIdChange },
                              model: {
                                value: _vm.criteriaTag,
                                callback: function($$v) {
                                  _vm.criteriaTag = $$v
                                },
                                expression: "criteriaTag"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("SearchableDropdown", {
                      staticClass: "filter-comparison-type",
                      attrs: {
                        config: _vm.comparisonOptions,
                        placeholder: _vm.$t("ROUTER_TAG_SELECT_PH"),
                        rules: "required"
                      },
                      on: { change: _vm.handleComparisonTypeChange },
                      model: {
                        value: _vm.criteriaComparisonType,
                        callback: function($$v) {
                          _vm.criteriaComparisonType = $$v
                        },
                        expression: "criteriaComparisonType"
                      }
                    }),
                    _vm._v(" "),
                    _vm.criteriaComparisonType.key != "EXISTS"
                      ? _c("CriteriaValueInput", {
                          attrs: {
                            "is-full-width": _vm.isFullWidth,
                            criteria: _vm.criteria,
                            "bulk-tags-uploads": _vm.bulkTagUploads
                          },
                          on: { duplicateFile: _vm.handleDuplicateFile },
                          model: {
                            value: _vm.criteriaValue,
                            callback: function($$v) {
                              _vm.criteriaValue = $$v
                            },
                            expression: "criteriaValue"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-function filter-or-criteria__remove",
                    on: {
                      click: function($event) {
                        return _vm.removeRule()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditView || _vm.isReadOnly
            ? _c("OrCriteriaSummary", {
                attrs: {
                  criteria: _vm.orCriteria,
                  "is-read-only": _vm.isReadOnly,
                  "available-tags": _vm.availableTags
                },
                on: { edit: _vm.enableEditView }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }